import { Routes } from '@angular/router';

// Components
import { SurveyListComponent } from './Components/survey-list/survey-list.component';
import { SurveyCreateComponent } from './Components/survey-create/survey-create.component';
import { SurveyEditComponent } from './Components/survey-edit/survey-edit.component';

export const surveyRoutes: Routes = [
    { path: 'survey', component: SurveyListComponent, data: { title: 'Survey', icon: 'assignment', primary: true }},
    { path: 'survey/add', component: SurveyCreateComponent, data: { primary: false }},
    { path: 'survey/:id', component: SurveyListComponent, data: { primary: false }},
    { path: 'survey/edit/:id', component: SurveyEditComponent, data: { primary: false }},
];